import axios from "axios";

const axiosInstance = axios.create({
   baseURL: "https://api.engineeringprojectskart.com",
 // baseURL: "https://edwin-backend-app.adaptable.app",
});

export default axiosInstance;
